import createDeviceMetrics from './device';
import createDocumentMetrics from './document';
import createMetadataMetrics from './metadata';
import createNetworkMetrics from './network';

export default function createMetricMetadata() {
    const deviceMetadata = createDeviceMetrics();
    const metadata = createMetadataMetrics();
    const networkMetadata = createNetworkMetrics();
    const documentMetrics = createDocumentMetrics();

    return Object.assign(
        {},
        deviceMetadata,
        metadata,
        networkMetadata,
        documentMetrics,
    );
}
